import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Grid, Row, Col } from 'react-flexbox-grid';

import bem from '../../../common/bem'

export default class PageContent extends Component {
  constructor() {
    super()
  }

  render() {

    const bemmer = bem('pagecontent')
    const { children, className, isRaw } = this.props
    let outerBemmer = !isRaw ? bemmer.element('container') : bemmer.element('raw-container')

    outerBemmer = className ? outerBemmer.withClass(className) : outerBemmer

    return (
        <section className={outerBemmer}>
          { children }
        </section>
    )
  }
}

PageContent.propTypes = {
  className: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
  ])
}

PageContent.defaultProps = {
  isRaw: false
}



// WEBPACK FOOTER //
// ./component/ui/Page/PageContent.js